// KPO-135 helper: pick the target route when leaving fill-form
// (draft delete, cancel). Landing on "/" auto-redirects to the sole
// remaining active form for ROLE_USER, which is exactly the bug we're
// fixing — always land on the forms list instead.
export const postFormExitPath = (authorities) => {
  const isUser = typeof authorities === "string"
    && authorities.split(",").includes("ROLE_USER");
  return isUser ? "/forms/active" : "/forms";
};

// KPO-195 helper: tooltip for the "Zapisz i wyślij" submit button on
// fill-form. The deadline that matters depends on the flow: in edit
// mode it's editableUntil (per-filling edit window), in a fresh fill
// it's the ScheduledForm.endDate. timeToGo === "---" means the clock
// below the form hit zero. Previously the tooltip reused the draft-save
// copy here, which was misleading on edit URLs where draft doesn't apply.
export const submitButtonTooltip = ({ timeToGo, isEdit }) => {
  if (timeToGo !== "---") {
    return "Wyślij formularz i zapisz na serwerze.";
  }
  return isEdit
    ? "Czas na edycję formularza minął"
    : "Czas na wypełnienie formularza minął";
};
